import { authGet } from "@api";
import { Permission } from "@types";

import { ListPoliciesResponse } from "@pages/policies/types";

/*
 * Fetches policies and rulesets in those policies from deployment
 */
export const fetchPoliciesIfPermitted = (
  deploymentId: string,
  permissions: Permission[],
  withStats: boolean = true
): Promise<ListPoliciesResponse> => {
  if (!permissions.includes(Permission.panel_policy)) {
    return Promise.resolve({ policies: [], rulesets: [] });
  }

  let path = `/api/agent/deployments/${deploymentId}/policies`;
  if (withStats) {
    path = path + "?stats=1";
  } else {
    path = path + "?stats=0";
  }
  return authGet<ListPoliciesResponse>(path);
};
